import { OSKIconDefinition } from '../osk-icon.types';

export const oskIconChevronDown: OSKIconDefinition = {
  name: 'chevron-down',
  content: '<path d="m6 9 6 6 6-6" />'
};
